module.exports = __webpack_public_path__ + "img/eatDoradoLogo.bf5e4876.png";